import React from "react";

export function Spinner() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
      style={{
        shapeRendering: "auto",
      }}
    >
      <g>
        <g transform="rotate(0 50 50)">
          <rect fill="#0d83c7" height="10" width="10" ry="5" rx="5" y="24" x="45">
            <animate repeatCount="indefinite" begin="-0.7s" dur="0.8s" keyTimes="0;1" values="1;0" attributeName="opacity"></animate>
          </rect>
        </g>
        <g transform="rotate(45 50 50)">
          <rect fill="#0d83c7" height="10" width="10" ry="5" rx="5" y="24" x="45">
            <animate repeatCount="indefinite" begin="-0.6s" dur="0.8s" keyTimes="0;1" values="1;0" attributeName="opacity"></animate>
          </rect>
        </g>
        <g transform="rotate(90 50 50)">
          <rect fill="#0d83c7" height="10" width="10" ry="5" rx="5" y="24" x="45">
            <animate repeatCount="indefinite" begin="-0.5s" dur="0.8s" keyTimes="0;1" values="1;0" attributeName="opacity"></animate>
          </rect>
        </g>
        <g transform="rotate(135 50 50)">
          <rect fill="#0d83c7" height="10" width="10" ry="5" rx="5" y="24" x="45">
            <animate repeatCount="indefinite" begin="-0.4s" dur="0.8s" keyTimes="0;1" values="1;0" attributeName="opacity"></animate>
          </rect>
        </g>
        <g transform="rotate(180 50 50)">
          <rect fill="#0d83c7" height="10" width="10" ry="5" rx="5" y="24" x="45">
            <animate repeatCount="indefinite" begin="-0.3s" dur="0.8s" keyTimes="0;1" values="1;0" attributeName="opacity"></animate>
          </rect>
        </g>
        <g transform="rotate(225 50 50)">
          <rect fill="#0d83c7" height="10" width="10" ry="5" rx="5" y="24" x="45">
            <animate repeatCount="indefinite" begin="-0.2s" dur="0.8s" keyTimes="0;1" values="1;0" attributeName="opacity"></animate>
          </rect>
        </g>
        <g transform="rotate(270 50 50)">
          <rect fill="#0d83c7" height="10" width="10" ry="5" rx="5" y="24" x="45">
            <animate repeatCount="indefinite" begin="-0.1s" dur="0.8s" keyTimes="0;1" values="1;0" attributeName="opacity"></animate>
          </rect>
        </g>
        <g transform="rotate(315 50 50)">
          <rect fill="#0d83c7" height="10" width="10" ry="5" rx="5" y="24" x="45">
            <animate repeatCount="indefinite" begin="0s" dur="0.8s" keyTimes="0;1" values="1;0" attributeName="opacity"></animate>
          </rect>
        </g>
        <g></g>
      </g>
    </svg>
  )
}
